export enum ValveTypeEnum {
  OFF,
  ONE,
  TWO,
  SHAR,
}
